//******************************************************
//*****    Script Resource: ComponentLayoutVertical
//******************************************************
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
import { tgfComponents } from "./tgfComponents";
// ***************************************
// ComponentLayoutVertical
//
// This component lays out a number of components vertically
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2-7-2015
// ***************************************
// Directives for jslint
/*global tgfComponents, tgfScale, tgfSettings */
tgfSettings.componentDefaults.layoutVertical = {
    width: 400,
    height: 400,
    alignment: "top",
    componentHeight: 90,
    componentGap: 8,
    adaptHeight: true,
    adaptWidth: true,
    components: [] // Components to add as children
};
// The constructor for the component
export var ComponentLayoutVertical = function (properties) {
    "use strict";
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.layoutVertical);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base component
tgfComponents.inherit(ComponentLayoutVertical, ComponentBase);
// ***************************************
// Specific methods for this component
// ***************************************
// Layout (reposition and resize) the sub components based on the (changed) settings
ComponentLayoutVertical.prototype.layout = function () {
    "use strict";
    var i, adaptWidth, adaptHeight, componentHeight, totHeight, gap, top, h;
    // Change the sizes of the components
    adaptWidth = [].concat(this.adaptWidth);
    adaptHeight = [].concat(this.adaptHeight);
    componentHeight = [].concat(this.componentHeight);
    totHeight = 0;
    for (i = 0; i < this.components.length; i += 1) {
        h = componentHeight[i % componentHeight.length];
        if (adaptWidth[i % adaptWidth.length]) {
            this.components[i].width = this.width;
        }
        if (adaptHeight[i % adaptHeight.length]) {
            this.components[i].height = h;
        }
        totHeight += h;
    }
    totHeight += (this.components.length - 1) * this.componentGap;
    // Set the alignment
    gap = this.componentGap;
    switch (this.alignment) {
        case "top":
            top = -this.height / 2;
            break;
        case "middle":
            top = -totHeight / 2;
            break;
        case "bottom":
            top = this.height / 2 - totHeight;
            break;
        case "spread":
            top = -this.height / 2;
            gap += (this.height - totHeight) / (this.components.length - 1);
            break;
        default: top = -this.height / 2;
    }
    // Now set the y-position
    for (i = 0; i < this.components.length; i += 1) {
        h = componentHeight[i % componentHeight.length];
        this.components[i].y = Math.round(top + h / 2);
        top += h + gap;
    }
};
// ***************************************
// Preparing, showing and activating
// ***************************************
// Processing required when preparing the component for use
ComponentLayoutVertical.prototype.doPrepare = function () {
    "use strict";
    var i;
    // Layout the child components
    this.layout();
    // Add the child components
    for (i = 0; i < this.components.length; i += 1) {
        this.addComponent(this.components[i]);
    }
};
//******************************************************
//*****    Script Resource: ComponentLayoutHorizontal
//******************************************************
// ***************************************
// ComponentLayoutHorizontal
//
// This component lays out a number of components horizontally
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2-7-2015
// ***************************************
// Directives for jslint
/*global tgfComponents, tgfScale, tgfSettings */
tgfSettings.componentDefaults.layoutHorizontal = {
    width: 400,
    height: 400,
    alignment: "center",
    componentWidth: 90,
    componentGap: 8,
    adaptHeight: true,
    adaptWidth: true,
    components: [] // Components to add as children
};
// The constructor for the component
export var ComponentLayoutHorizontal = function (properties) {
    "use strict";
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.layoutHorizontal);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base component
tgfComponents.inherit(ComponentLayoutHorizontal, ComponentBase);
// ***************************************
// Specific methods for this component
// ***************************************
// Layout (reposition and resize) the sub components based on the (changed) settings
ComponentLayoutHorizontal.prototype.layout = function () {
    "use strict";
    var i, adaptWidth, adaptHeight, componentWidth, totWidth, gap, left, w;
    // Change the sizes of the components
    adaptWidth = [].concat(this.adaptWidth);
    adaptHeight = [].concat(this.adaptHeight);
    componentWidth = [].concat(this.componentWidth);
    totWidth = 0;
    for (i = 0; i < this.components.length; i += 1) {
        w = componentWidth[i % componentWidth.length];
        if (adaptWidth[i % adaptWidth.length]) {
            this.components[i].width = w;
        }
        if (adaptHeight[i % adaptHeight.length]) {
            this.components[i].height = this.height;
        }
        totWidth += w;
    }
    totWidth += (this.components.length - 1) * this.componentGap;
    // Set the alignment
    gap = this.componentGap;
    switch (this.alignment) {
        case "left":
            left = -this.width / 2;
            break;
        case "center":
            left = -totWidth / 2;
            break;
        case "right":
            left = this.width / 2 - totWidth;
            break;
        case "spread":
            left = -this.width / 2;
            gap += (this.width - totWidth) / (this.components.length - 1);
            break;
        default: left = -this.width / 2;
    }
    // Now set the x-position
    for (i = 0; i < this.components.length; i += 1) {
        w = componentWidth[i % componentWidth.length];
        this.components[i].x = Math.round(left + w / 2);
        left += w + gap;
    }
};
// ***************************************
// Preparing, showing and activating
// ***************************************
// Processing required when preparing the component for use
ComponentLayoutHorizontal.prototype.doPrepare = function () {
    "use strict";
    var i;
    // Layout the child components
    this.layout();
    // Add the child components
    for (i = 0; i < this.components.length; i += 1) {
        this.addComponent(this.components[i]);
    }
};
